export default __webpack_public_path__ + "static/media/paps-gift.756ca0c9.png";